<template>
	<div>
		<div class="logobox">
			<img src="../../../static/img/logo.png" class="logo">
		</div>
		<it-header-menu @selectMenu="selectMenu"></it-header-menu>
		<div>
			<Dropdown class="adminbox" @on-click="logout">
				<span class="hospitalName">{{ userName }}</span>
				<Avatar class="admin" icon="ios-person" src="https://i.loli.net/2017/08/21/599a521472424.jpg"
					size="large" />
				<DropdownMenu slot="list">
					<DropdownItem :name="i.index" :divided="i.divided" v-for="i in DropList" :key="i.index">{{ i.name }}
					</DropdownItem>
					<!-- <DropdownItem :name="1">修改密码</DropdownItem>
					<DropdownItem :name="3">个人模板</DropdownItem>
					<DropdownItem :divided="true" :name="2">安全退出</DropdownItem> -->
				</DropdownMenu>
			</Dropdown>
		</div>
		<!-- 个人信息 -->
		<Modal v-model="information" :width="700" title="个人信息" @on-ok="updateDoctor">
			<Form class="informationForm" ref="formData" :model="formData" :rules="ruleInline">
				<h3>基本信息</h3>
				<FormItem class="formItem" label="姓名" :label-width="80" prop="nickname">
					<Input v-model="formData.nickname"></Input>
				</FormItem>
				<FormItem class="formItem" label="性别" :label-width="80">
					<RadioGroup v-model="formData.sex">
						<Radio :label="i.value" v-for="i in dictionary.sex" :key="i.id">
							<span>{{ i.name }}</span>
						</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem class="formItem" label="年龄" :label-width="80">
					<Input v-model="formData.age">
					<Select v-model="ageOpt" slot="append" style="width: 70px">
						<Option value="岁">岁</Option>
						<Option value="月">月</Option>
						<Option value="天">天</Option>
					</Select>
					</Input>
				</FormItem>
				<FormItem class="formItem" label="所在科室" :label-width="80" prop="department.deptName">
					<Input v-model="formData.department.deptName" @on-focus="selectDepartment">
					<Button slot="append" @click="selectDepartment">选择</Button>
					</Input>
				</FormItem>
				<FormItem class="formItem" label="医学职称" :label-width="80">
					<Select v-model="formData.rank">
						<OptionGroup multiple :label="medical.name"
							v-for="medical in treeData(dictionary.medical, 'ownerId', 'id')" :key="medical.id">
							<Option :value="i.name" :key="i.id"
								v-for="i in medical.children ? medical.children : [medical]">{{
									i.name }}</Option>
						</OptionGroup>
					</Select>
				</FormItem>
				<FormItem class="formItem" label="教学职称" :label-width="80">
					<Select v-model="formData.rankEdu">
						<OptionGroup :label="teach.name" v-for="teach in treeData(dictionary.teach, 'ownerId', 'id')"
							:key="teach.id">
							<Option :value="i.name" :key="i.id" v-for="i in teach.children ? teach.children : [teach]">{{
								i.name
							}}</Option>
						</OptionGroup>
					</Select>
				</FormItem>
				<FormItem class="formItem" label="学历" :label-width="80">
					<Select v-model="formData.rankAcademic">
						<OptionGroup :label="education.name"
							v-for="education in treeData(dictionary.education, 'ownerId', 'id')" :key="education.id">
							<Option :value="i.name" :key="i.id"
								v-for="i in education.children ? education.children : [education]">{{ i.name }}</Option>
						</OptionGroup>
					</Select>
				</FormItem>
				<FormItem class="formItem" label="职务" :label-width="80">
					<Select v-model="formData.rankAdmin">
						<OptionGroup :label="medical.name" v-for="medical in treeData(dictionary.duties, 'ownerId', 'id')"
							:key="medical.id">
							<Option :value="i.name" :key="i.id"
								v-for="i in medical.children ? medical.children : [medical]">{{
									i.name }}</Option>
						</OptionGroup>
					</Select>
				</FormItem>
				<div>
					<p style="text-indent:60px">资质图片(职业医师资格证等)[最多上传10张]</p>
					<FormItem :label-width="40">
						<image-uploade @imgList="imgList" :updateData="updateData"></image-uploade>
					</FormItem>
				</div>
				<div>
					<FormItem label="签名" :label-width="80">
						<div class="elecSignBox">
							<div>
								<Upload action="/api/file/fileUpload" :on-success="elecSignSuccess"
									:show-upload-list="false">
									<Button type="success" ghost icon="ios-cloud-upload-outline">上传签名</Button>
								</Upload>
							</div>
							<img class="elecSignPic" v-if="!elecSignfileMd5 ? false : true"
								:src="elecSignfileMd5 ? '/api/file/acquisition/' + elecSignfileMd5 : '/api/file/acquisition/' + updateData.doctorInfo.elecSign"
								alt="">
							<img src="" alt="">
						</div>
					</FormItem>
				</div>
				<div>
					<FormItem class="longItem" label="个人简介" :label-width="80">
						<Input type="textarea" :rows="5" v-model="formData.introduction"></Input>
					</FormItem>
				</div>
			</Form>
		</Modal>
		<!-- 科室 -->
		<Modal v-model="department" @on-ok="checkDepartment" title="选择科室">
			<Tree ref="tree" :data="treeData(allData, 'parentCode', 'code')"></Tree>
		</Modal>

		<!-- 修改密码 -->
		<Modal v-model="updatePassword" @on-ok="passwordchange('formValidate')" @on-cancel="cancel('formValidate')"
			:loading="loading" title="密码修改">
			<Form ref="formValidate" :model="passWordForm" :rules="rulePassWordForm" :label-width="80">
				<FormItem label="旧密码" prop="password">
					<Input type="password" v-model="passWordForm.password" placeholder="请输入旧密码" />
				</FormItem>
				<FormItem label="新密码" prop="newPassword1">
					<Input type="password" v-model="passWordForm.newPassword1" placeholder="请输入新密码" />
				</FormItem>
				<FormItem label="新密码" prop="newPassword2">
					<Input type="password" v-model="passWordForm.newPassword2" placeholder="请再次输入新密码" />
				</FormItem>
			</Form>
		</Modal>

		<Modal v-model="template" :loading="loading" footer-hide :width="800" title="个人模板">
			<Select v-model="deviceType" @on-change="findTemplateList" style="float: left; width:200px">
				<Option value="CT">CT</Option>
				<Option value="MR">MR</Option>
				<Option value="x线">x线</Option>
			</Select>

			<Input v-model="keywords" style="float: left; width:400px; margin-left: 10px; color:#ca0e0e7e" @on-enter="findTemplateList"
				placeholder="疾病标题、分类、关键词">
			<Button slot="append" icon="ios-search" style="background:#2d8cf0;color:white"
				@click="findTemplateList"></Button>
			</Input>
			<Button style="background:#0b8088;color:white; float: right;"
				@click="addOrUpdateTemplateShowUI('1')">新增</Button>
			<div style="margin-top:40px; clear:both;">
				<Table :columns="templateColumns" :data="templates"></Table>
				<div class="pageBox">
					<Page class="page" :page-size="page.pageSize" show-total :current="page.current" :total="page.total"
						@on-change="changeTemplatePage" />
				</div>
			</div>
		</Modal>

		<Modal v-model="updatePerTemplate" width="700" :styles="{ top: '20px' }" title="新增/修改个人模板">
			<Form ref="perTemplateForm" :model="perTemplateForm" :rules="perTemplateFormRule" :label-width="80"
				label-position="left">
				<Row>
					<FormItem label="检查类型" prop="deviceType">
						<RadioGroup v-model="perTemplateForm.deviceType">
							<Radio label="x线">x线</Radio>
							<Radio label="CT">CT</Radio>
							<Radio label="MR">MR</Radio>
						</RadioGroup>
					</FormItem>
				</Row>
				<Row>
					<FormItem label="疾病分类" prop="diseaseType">
						<Select v-if="!diseaseTypeWrite" v-model="perTemplateForm.diseaseType" style="width:300px">
							<Option v-for="(item, index) in diseasesPerList" :value="item" :key="index">{{ item }}</Option>
						</Select>
						<Input v-if="diseaseTypeWrite" v-model="perTemplateForm.diseaseType" placeholder="请输入所属分类"
							style="width: 300px" />
						<Button type="primary" @click="diseaseTypeWrite = !diseaseTypeWrite"
							v-html="diseaseTypeWrite ? '选择分类' : '新增分类'"></Button>
					</FormItem>
				</Row>
				<Row>
					<FormItem label="标题" prop="title">
						<Input v-model="perTemplateForm.title" placeholder="标题（可以采用疾病名称）"></Input>
					</FormItem>
				</Row>
				<Row>
					<FormItem label="关键词设置" prop="diseaseName">
						<Input v-model="diseaseName" @on-enter="addDiseaseName" placeholder="回车生成用于搜索的关键词标签"
							style="width: 504px"></Input>
						<Button type="info" @click="deleteDiseaseName" v-html="'清除标签'"></Button>
						<Tag type="border" color="primary" v-for="(i, index) in diseaseNameList" :key="index">
							{{ i }}</Tag>
					</FormItem>
				</Row>
				<FormItem label="阴阳性" prop="isNormal">
					<RadioGroup v-model="perTemplateForm.isNormal">
						<Radio label="0">阴性</Radio>
						<Radio label="1">阳性</Radio>
					</RadioGroup>
				</FormItem>
				</Row>
				<Row>
					<FormItem label="征像描述" prop="description">
						<Input v-model="perTemplateForm.description" type="textarea" :autosize="{ minRows: 4, maxRows: 6 }"
							placeholder="影像所见/征像描述"></Input>
					</FormItem>
				</Row>
				<Row>
					<FormItem label="诊断建议" prop="contents">
						<Input v-model="perTemplateForm.contents" type="textarea" :autosize="{ minRows: 4, maxRows: 6 }"
							placeholder="诊断建议/影像提示"></Input>
					</FormItem>
				</Row>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateMyTemplate">保存</Button>
				<Button style="margin-left: 8px" @click="cancelSaveTemplate">取消</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
import ItHeaderMenu from './ItHeaderMenu'
import Cookies from "js-cookie";
import imageUploade from "../imageUploade/imageUploade.vue"
export default {
	watch: {
		'perTemplateForm.deviceType': {
			handler(value) {
				this.searchdiseasesPerList()
			}
		}
	},
	name: "ItHeader",
	data() {
		return {
			page: {
				pageSize: 10,
				current: 1,
				total: 0,
			},
			keywords: '',
			diseaseType: '',
			deviceType: "",
			diseaseNameList: [],
			diseasesPerList: [],
			diseaseName: '',
			diseaseTypeWrite: false,
			updatePerTemplate: false,

			perTemplateForm: {
				deviceType: "",
				diseaseName: '',
				title: "",
				isNormal: "",
				description: "",
				contents: ""
			},

			templateColumns: [
				{
					title: '标题',
					key: 'title'
				},
				{
					title: '分类',
					width: 80,
					key: 'diseaseType'
				},
				{
					title: '关键词',
					width: 80,
					key: 'diseaseName'
				},
				{
					title: '影像提示/诊断建议',
					align: 'center',
					width: 300,
					key: 'contents',
					render: (h, params) => {
						let contents = params.row.contents
						if (contents.length > 100) {
							contents = contents.substring(0, 100) + '...'
						}
						return h('span', contents)
					}
				},
				{
					title: '操作',
					align: 'center',
					width: 160,
					render: (h, params) => {
						return h('div', [
							h('Button', {
								props: {
									type: 'info',
									size: 'small'
								},
								style: {
									marginRight: '0px'
								},
								on: {
									click: () => {
										this.perTemplateForm = params.row
										this.addOrUpdateTemplateShowUI('2')
									}
								}
							}, [
								h('span', '修改')
							]),
							h('Button', {
								props: {
									type: 'warning',
									size: 'small'
								},
								style: {
									marginLeft: '2px'
								},
								on: {
									click: () => {
										let id = params.row.id;
										this.$Modal.confirm({
											title: '提示',
											content: '<p>您确认删除该模板吗？</p>',
											onOk: () => {
												this.$api.data.deleteTemplateSelf(id).then(res => {
													if (res.code == 0) {
														this.findTemplateList();
													}
												})
											}
										});
									}
								}
							}, [
								h('span', '删除')
							]),

						])
					}
				}
			],
			templates: [],
			template: false,


			perTemplateFormRule: {
				diseaseType: [
					{ required: true, message: '疾病分类不能为空', trigger: this.diseaseTypeWrite ? 'blur' : 'change' }
				],
				title: [
					{ required: true, message: '标题不能为空', trigger: 'blur' }
				],
				deviceType: [
					{ required: true, message: '检查类型不能为空', trigger: 'change' }
				],
				isNormal: [
					{ required: true, message: '阴阳性不能为空', trigger: 'change' }
				],
				description: [
					{ required: true, message: '征像描述不能为空', trigger: 'change' }
				],
				contents: [
					{ required: true, message: '诊断建议不能为空', trigger: 'change' }
				]
			},



			information: false,
			department: false,
			updatePassword: false,
			loading: true,
			allData: [],
			formData: {
				department: {
					deptName: ""
				}
			},
			ruleInline: {},
			passWordForm: {},
			rulePassWordForm: {
				password: [
					{ required: true, message: '旧密码不能为空', trigger: 'blur' }
				],
				newPassword1: [
					{ required: true, message: '新密码不能为空', trigger: 'blur' }
				],
				newPassword2: [
					{ required: true, message: '请再次输入新密码', trigger: 'blur' }
				]
			},
			dictionary: {
				sex: [],
				medical: [],
				duties: [],
				doctorType: [],
				teach: [],
				education: []
			},
			ageOpt: "",
			elecSignfileMd5: "",
			updateData: "",
			imgListData: [],
			DropList: [
				{
					name: "个人信息",
					index: 1
				}, {
					name: "修改密码",
					index: 2
				}, {
					name: "个人模板",
					index: 3
				}, {
					name: "安全退出",
					divided: true,
					index: 4
				}
			]
		}
	},
	components: {
		ItHeaderMenu,
		imageUploade
	},
	methods: {
		searchdiseasesPerList() {
			let data = {
				deviceType: this.perTemplateForm.deviceType
			}
			this.$api.data.findTemplateReportDiseaseType(data).then((res) => {
				this.diseasesPerList = res.list
			})
		},
		cancelSaveTemplate() {
			this.updatePerTemplate = false;
		},
		addDiseaseName() {
			this.diseaseNameList.push(this.diseaseName)
			this.diseaseName = ""
		},
		deleteDiseaseName() {
			this.diseaseNameList = []
		},
		addOrUpdateTemplateShowUI(type) {
			// 新增
			if (type == '1') {
				this.$refs.perTemplateForm.resetFields();

                this.diseaseTypeWrite = false;
                this.diseaseNameList = []

                this.perTemplateForm = {
                    deviceType: this.deviceType || "",
                    diseaseType: "",
                    diseaseName: '',
                    title: "",
                    description: "",
                    contents: ""
                };

                this.searchdiseasesPerList()

                this.updatePerTemplate = true
			}
			// 修改
			else if (type == '2') {
				let diseaseName = this.perTemplateForm.diseaseName
				if (diseaseName && diseaseName.trim()) {
                    this.diseaseNameList = diseaseName.split(',')
                } else {
                    this.diseaseNameList = []
                }
				this.updatePerTemplate = true
			}
		},

		addOrUpdateMyTemplate() {
			this.$refs.perTemplateForm.validate((valid) => {
				if (valid) {
					let data = JSON.parse(JSON.stringify(this.perTemplateForm))
					data.diseaseName = this.diseaseNameList.join(",")
					if (data.diseaseName == '') {
						data.diseaseName = ' '
					}
					this.$api.data.addOrUpdateTemplateSelf(data).then((res) => {
						if (res.code == 0) {
							this.updatePerTemplate = false
							this.deviceType = data.deviceType;
							this.findTemplateList();
						}
					})
				}
			})
		},
		findTemplateList() {
			this.template = true
			let data = {
				pageNumber: this.page.current,
				pageSize: this.page.pageSize,
				deviceType: this.deviceType,
				keywords: this.keywords
			}
			this.$api.data.findTemplateReportSelf(data).then((res) => {
				this.templates = res.list
				this.page.total = res.totalCount
			})
		},
		changeTemplatePage(value) {
			this.page.current = value
			this.findTemplateList()
		},
		selectMenu(value) {
			this.$emit('selectMenu', value)
		},
		upDateInfo() {
			let doctor = {
				id: JSON.parse(window.sessionStorage.getItem("user")).id,
				t: new Date().getTime()
			}
			this.$api.doctor.doctorInfo(doctor).then((res) => {
				let doctorInfo = res.user
				this.formData.nickname = doctorInfo.nickname
				this.formData.sex = doctorInfo.doctorInfo.sex
				this.formData.age = doctorInfo.doctorInfo.age
				this.formData.rank = doctorInfo.doctorInfo.rank
				this.formData.rankEdu = doctorInfo.doctorInfo.rankEdu
				this.formData.department.deptName = doctorInfo.doctorInfo.office
				this.formData.rankAcademic = doctorInfo.doctorInfo.rankAcademic
				this.formData.rankAdmin = doctorInfo.doctorInfo.rankAdmin
				this.updateData = doctorInfo.doctorInfo.authCertificate
				this.elecSignfileMd5 = doctorInfo.doctorInfo.elecSign
				this.formData.introduction = doctorInfo.doctorInfo.introduction
				this.formData.id = doctorInfo.id
				this.formData.formDataInfoId = doctorInfo.doctorInfo.id
				this.formData.salt = doctorInfo.salt
				this.formData.username = doctorInfo.username
				let sex = {
					dictionaryType: 'sex'
				}
				let medical = {
					dictionaryType: 'medical_title'
				}
				let teach = {
					dictionaryType: 'teaching title'
				}
				let education = {
					dictionaryType: 'education'
				}
				let duties = {
					dictionaryType: 'hospital_duties'
				}
				this.$api.dictionary.findByType(sex).then((resSex) => {//性别字典
					this.$set(this.dictionary, "sex", resSex.list)
					this.information = true
				})
				this.$api.dictionary.findByType(medical).then((resMedical) => {//医学职称
					this.$set(this.dictionary, "medical", resMedical.list)
				})
				this.$api.dictionary.findByType(teach).then((resTeach) => {//教学职称
					this.$set(this.dictionary, "teach", resTeach.list)
				})
				this.$api.dictionary.findByType(education).then((resEducation) => {//学历
					this.dictionary.education = resEducation.list
				})
				this.$api.dictionary.findByType(duties).then((resDuties) => {//职务
					this.dictionary.duties = resDuties.list
				})
			})
		},

		logout(value) {
			if (value == 1) {
				this.upDateInfo()
			} else if (value == 2) {
				this.updatePassword = true
			} else if (value == 3) {
				this.keywords = ''
				this.findTemplateList()
			} else if (value == 4) {
				this.loginOut()
			}
			// if(value==2){
			// let data={
			// 	t:new Date().getTime()
			// }
			// this.$api.login.loginout(data).then((res)=>{
			// 	window.sessionStorage.clear()
			// 	this.$router.push('/login')
			// 	Cookies.remove('token')
			// 	location.reload()
			// })
			// }else if(value == 0){
			// let doctor={
			// 	id: JSON.parse(window.sessionStorage.getItem("user")).id,
			// 	t: new Date().getTime()
			// }
			// this.$api.doctor.doctorInfo(doctor).then((res)=>{
			// 	let doctorInfo = res.user
			// 	this.formData.nickname = doctorInfo.nickname
			// 	this.formData.sex = doctorInfo.doctorInfo.sex
			// 	this.formData.age = doctorInfo.doctorInfo.age
			// 	this.formData.rank = doctorInfo.doctorInfo.rank
			// 	this.formData.rankEdu = doctorInfo.doctorInfo.rankEdu
			// 	this.formData.department.deptName = doctorInfo.doctorInfo.office
			// 	this.formData.rankAcademic = doctorInfo.doctorInfo.rankAcademic
			// 	this.formData.rankAdmin = doctorInfo.doctorInfo.rankAdmin
			// 	this.updateData = doctorInfo.doctorInfo.authCertificate
			// 	this.elecSignfileMd5 = doctorInfo.doctorInfo.elecSign
			// 	this.formData.introduction = doctorInfo.doctorInfo.introduction
			// 	this.formData.id = doctorInfo.id
			// 	this.formData.formDataInfoId = doctorInfo.doctorInfo.id
			// 	this.formData.salt = doctorInfo.salt
			// 	this.formData.username = doctorInfo.username
			// 	let sex={
			// 		dictionaryType:'sex'
			// 	}
			// 	let medical={
			// 		dictionaryType:'medical_title'
			// 	}
			// 	let teach={
			// 		dictionaryType:'teaching title'
			// 	}
			// 	let education={
			// 		dictionaryType:'education'
			// 	}
			// 	let duties={
			// 		dictionaryType:'hospital_duties'
			// 	}
			// 	this.$api.dictionary.findByType(sex).then((resSex)=>{//性别字典
			// 		this.$set(this.dictionary,"sex",resSex.list)
			// 		this.information = true
			// 	})
			// 	this.$api.dictionary.findByType(medical).then((resMedical)=>{//医学职称
			// 		this.$set(this.dictionary,"medical",resMedical.list)
			// 	})
			// 	this.$api.dictionary.findByType(teach).then((resTeach)=>{//教学职称
			// 		this.$set(this.dictionary,"teach",resTeach.list)
			// 	})
			// 	this.$api.dictionary.findByType(education).then((resEducation)=>{//学历
			// 		this.dictionary.education=resEducation.list
			// 	})
			// 	this.$api.dictionary.findByType(duties).then((resDuties)=>{//职务
			// 		this.dictionary.duties = resDuties.list
			// 	})
			// })
			// }else if(value== 1){
			// 	this.updatePassword = true
			// }else if(value == 3) {
			// 	this.template = true
			// }
		},
		selectDepartment() {
			this.$api.doctor.getlocalDept().then((res) => {
				this.allData = res.list
				for (let i in this.allData) {
					this.allData[i].title = this.allData[i].deptName
				}
				this.department = true
			})
		},
		elecSignSuccess(response, file, fileList) {
			if (response.code == 0) {
				this.elecSignfileMd5 = response.data.fileMd5
				this.$Message.info(response.msg)
			} else {
				this.$Message.info(response.msg)
			}
		},
		checkDepartment() {
			this.formData.department = this.$refs.tree.getSelectedNodes()[0]
		},
		imgList(value) {
			this.imgListData = value
		},
		updateDoctor() {
			let authCertificate = []
			for (let i in this.imgListData) {
				authCertificate.push(this.imgListData[i].url ? this.imgListData[i].url : this.imgListData[i].response.data.fileMd5)
			}
			let data = {
				doctorInfo: {
					age: this.formData.age,
					authCertificate: JSON.stringify(authCertificate),//资质图片
					elecSign: this.elecSignfileMd5,//电子签名
					introduction: this.formData.introduction,//简介
					office: this.formData.department.deptName,//科室
					rank: this.formData.rank,//医学职称
					rankAcademic: this.formData.rankAcademic,//学历
					rankAdmin: this.formData.rankAdmin,//职务
					rankEdu: this.formData.rankEdu,//教学职称
					sex: this.formData.sex,
					id: this.formData.formDataInfoId
				},
				nickname: this.formData.nickname,
				username: this.formData.username,
				id: this.formData.id,
				salt: this.formData.salt
			}
			this.$api.doctor.updateDoctor(data).then((res) => {
				this.$Message.info(res.msg)
			})
		},
		passwordchange(name) {
			this.$refs[name].validate((valid) => {
				if (valid) {
					if (this.passWordForm.newPassword1 === this.passWordForm.newPassword2) {
						let data = {
							password: this.passWordForm.password,
							newPassword: this.passWordForm.newPassword1
						}
						this.$api.doctor.userPassword(data).then((res) => {
							if (res.code == 0) {
								this.loading = false
								setTimeout(() => {
									this.loading = true
								})
								this.updatePassword = false
								this.$refs[name].resetFields();
							} else {
								this.loading = false
								this.$Message.error(res.msg)
								let time = setTimeout(() => {
									this.loading = true
								})
								clearTimeOut(time)
							}
						})
					} else {
						this.$Message.error("两次新密码输入不一致")
						this.loading = false
						let time = setTimeout(() => {
							this.loading = true
						})
						clearTimeOut(time)
					}
				} else {
					this.loading = false
					let time = setTimeout(() => {
						this.loading = true
					})
					clearTimeOut(time)
				}
			})
		},
		cancel(name) {
			this.$refs[name].resetFields();
		},
		loginOut() {
			let data = {
				t: new Date().getTime()
			}
			this.$api.login.loginout(data).then((res) => {
				window.sessionStorage.clear()
				this.$router.push('/login')
				Cookies.remove('token')
				location.reload()
			})
		}
	},
	computed: {
		userName() {
			let data = JSON.parse(window.sessionStorage.getItem('user'))
			return data.hospitals[0] && data.hospitals[0].title || ""
		},
		treeData() {
			return function (data, parentId, sonId) {
				data.forEach(function (item) {
					delete item.children;
				});
				var map = {};
				data.forEach(function (item) {
					map[item[sonId]] = item;
				});
				var val = [];
				data.forEach(function (item) {
					var parent = map[item[parentId]];
					if (parent) {
						(parent.children || (parent.children = [])).push(item);
					} else {
						val.push(item);
					}
				});
				return val;
			}

		}
	}
}
</script>

<style lang="scss" scoped>
.logobox {
	width: 190px;
	height: 64px;
	float: left;
	display: flex;
	justify-content: center;
	align-items: center;

	.logo {
		width: 150px;
		height: 55px;
	}
}

.menu {
	float: left;
	height: 64px;
}

.adminbox {
	float: right;
}

// .logobox{
// 	width: 150px;
// 	height:64px;
// 	float: left;
// 	.logo{
// 		width: 60px;
// 		height:60px;
// 	}
// }
// .menu{
// 	float: left;
// 	height: 64px;
// }
// .adminbox{
// 	float: right;
// 	margin-right: 20px;
.hospitalName {
	color: white;
}

// }
.informationForm {
	&:after {
		content: "";
		clear: both;
		display: block;
		overflow: hidden;
		font-size: 0;
		height: 0;
	}

	.formItem {
		width: 300px;
		float: left;
	}
}

.pageBox {
	padding-top: 10px;
	overflow: hidden;

	.page {
		float: right;
	}
}

// .elecSignBox{
// 	display: flex;
// 	.elecSignPic{
// 		width: 120px;
// 		height: 64px;
// 		margin-left: 20px;
// 	}
// }
</style>



// WEBPACK FOOTER //
// src/components/Header/ItHeader.vue